type ClassValue = string | number | boolean | null | undefined | ClassValue[] | { [key: string]: any };

export function filterClasses(...classNames: ClassValue[]) {
  return classNames
    .flat()
    .reduce<string[]>((acc, className) => {
      if (typeof className === "string" && className.trim()) {
        acc.push(className.trim());
      } else if (typeof className === "object" && className !== null) {
        Object.entries(className).forEach(([key, value]) => {
          if (value) acc.push(key);
        });
      }
      return acc;
    }, [])
    .join(" ");
}
